import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, LinearProgress } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ViewCustomerHealthScores({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const healthScores = [
        {
            label: "Recency",
            value: 90,
            trend: "up",
            trendValue: "90",
            description: "Last purchase was 2 days ago",
            color: "green",
        },
        {
            label: "Frequency",
            value: 85,
            trend: "up",
            trendValue: "85",
            description: "Purchases every 2 weeks on average",
            color: "green",
        },
        {
            label: "Monetary",
            value: 75,
            trend: "down",
            trendValue: "75",
            description: "Average order value decreased by 5%",
            color: "orange",
        },
        {
            label: "Refunds",
            value: 60,
            trend: "down",
            trendValue: "60",
            description: "High refund rate in last month",
            color: "purple",
        },
        {
            label: "Support Tickets",
            value: 95,
            trend: "up",
            trendValue: "95",
            description: "No recent critical support tickets",
            color: "green",
        },
    ];

    return (
        <Modal className="modal health_score_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <div className="lt">
                            <h2>John Doe</h2>
                            <p>CUST-001 · Loyal Customer</p>
                        </div>
                        <button className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="health_summary">
                        <h4>
                            Health Score<span className="score">81.0 <i className="arrow">▲</i></span><span className="score_change">4.2 in 30 days</span>
                        </h4>

                        <p>
                            Health score is good, driven by high frequency and recency, though refunds have increased slightly.
                        </p>
                    </div>

                    {/* Content */}
                    <div className="health_score_view">
                        {healthScores.map((item, index) => (
                            <div className="score_row" key={index}>
                                <div className="score_header">
                                    <label>{item.label}</label>

                                    <div className="score_meta">
                                        <span>{item.value}%</span>
                                        <span className={`trend ${item.trend}`}>
                                            {item.trendValue} <i className="arrow">{item.trend === "up" ? "▲" : "▼"}</i>
                                        </span>
                                    </div>
                                </div>

                                <div className="progress_flex">
                                    <p className="score_desc">{item.description}</p>
                                    <LinearProgress
                                        variant="determinate"
                                        value={item.value}
                                        className={`score_bar ${item.color}`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="recommended_actions">
                        <h4>Recommended Actions</h4>

                        <ul>
                            <li>
                                <EmailOutlinedIcon />
                                Send appreciation email
                            </li>
                            <li>
                                <FlagOutlinedIcon />
                                Flag for special offer
                            </li>
                        </ul>
                    </div>

                    {/* Footer */}
                    <div className="footer_btn_flex right">
                        <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
